import request from '@/utils/request'

export function getRoleList(data) {
  return request({ url: '/admin/role/list', method: 'post', data })
}

export function getAllRoles() {
  return request({ url: '/admin/role/all', method: 'post' })
}

export function createRole(data) {
  return request({ url: '/admin/role/create', method: 'post', data })
}

export function updateRole(data) {
  return request({ url: '/admin/role/update', method: 'post', data })
}

export function deleteRole(data) {
  return request({ url: '/admin/role/delete', method: 'post', data })
}

export function assignRoleMenu(data) {
  return request({ url: '/admin/role/assignMenu', method: 'post', data })
}

export function getRoleMenus(data) {
  return request({ url: '/admin/role/menus', method: 'post', data })
}
